// extracted by mini-css-extract-plugin
export default {"title_container":"TocViewDialog_title_container__eFvhu"};